import { ShoppingCart } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ActionButtonsProps {
  quantity: number;
  totalPrice: number;
  unit: string;
  onAddToCart: () => void;
  loading?: boolean;
}

export function ActionButtons({
  quantity,
  totalPrice,
  unit,
  onAddToCart,
  loading,
}: ActionButtonsProps) {
  const { t } = useTranslation('product');
  return (
    <div className="flex flex-col transition-colors shadow-sm rounded-lg text-neut-0">
      <div className="bg-prim-400 px-4 py-2.5 border-b border-white/20 flex items-center justify-between rounded-t-[inherit]">
        <span className="text-xs text-white/80">
          {t('product.total_price')}:
        </span>
        <span
          data-testid="total-price"
          className="text-xl text-white font-semibold"
        >
          ${totalPrice.toLocaleString()}
        </span>
      </div>

      <button
        disabled={loading || quantity === 0}
        onClick={onAddToCart}
        className="px-4 py-3 flex items-center justify-center gap-2 border-red-500 rounded-b-[inherit] bg-prim-500 cursor-pointer hover:bg-prim-600 disabled:cursor-not-allowed transition-colors"
      >
        <ShoppingCart className="w-4 h-4" aria-hidden="true" />
        {loading ? (
          <span className="font-medium">{t('product.adding')}</span>
        ) : (
          <span className="font-medium">
            {t('product.add_to_cart')} ({quantity} {unit})
          </span>
        )}
      </button>
    </div>
  );
}
